import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { SWRegistrar } from './components/SWRegistrar';
import { OfflineBanner } from './components/OfflineBanner';

import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { queryClient },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Exponer el motor en `window.__regicide__` en DEV para que los
// tests E2E puedan jugar partidas programáticamente (ver
// `frontend/e2e/full-game.spec.ts`). En producción NO se expone.
if (import.meta.env.DEV) {
  void import('./game').then((m) => {
    (window as unknown as { __regicide__: typeof m }).__regicide__ = m;
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <SWRegistrar />
    <OfflineBanner />
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
